export const getDoubleBookingRulesInitialValues = (members) => ({
  doubleBookingRuleMemberships: members.map(({
    id, userId, userUuid,
    organizationInvitationId, organizationInvitationUuid, isPending,
    availableHours, dateOverrides, timezone,
    avatar, name,
    doubleBookingRules,
  }) => (
    {
      id,
      userId,
      userUuid,
      organizationInvitationId,
      organizationInvitationUuid,
      isPending,
      availableHours,
      dateOverrides,
      timezone,
      avatar,
      name,
      doubleBookingRules
    }
  ))
})

export const MEMBER_PREVIEW_DOUBLE_BOOKING_ATTRIBUTES = ['doubleBookingRules']
